import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { MainNavigation as BaseNavigation } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import systemBrandPayload from '@components/systemBrands/default'
import generateMainNavigationItems from '@sections/Client/utils/generateMainNavigationItems'

interface MainNavigationProps {
  minimized: boolean,
  nestedNavigation: React.ReactNode,
}

const MainNavigation = (props: MainNavigationProps) => {
  const { minimized, nestedNavigation } = props

  const navigationItems = useMemo(() => generateMainNavigationItems(), [])

  const { callbacks: { toggleNavigation }, showNavigation } = useMainNavigation()

  return (
    <BaseNavigation
      callbacks={{ toggleSidebar: toggleNavigation }}
      minimized={minimized}
      navigationItems={navigationItems}
      nestedNavigation={nestedNavigation}
      nestedNavigationWidth={240}
      showNavigation={showNavigation}
      systemBrandPayload={systemBrandPayload}
    />
  )
}

MainNavigation.propTypes = {
  minimized: PropTypes.bool,
  nestedNavigation: PropTypes.node,
}

export default MainNavigation
